import { render } from "./wfEmailTemplateEditor.vue?vue&type=template&id=7b84d35f"
import script from "./wfEmailTemplateEditor.vue?vue&type=script&lang=js"
export * from "./wfEmailTemplateEditor.vue?vue&type=script&lang=js"

import "./wfEmailTemplateEditor.vue?vue&type=style&index=0&id=7b84d35f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__